import { TenantService as service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const TenantManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return service.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const exportar = (where) => {
    return service.exportar(where).then((res) => {
      return res;
    });
  };

  const reporte = (where) => {
    return service.reporte(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const reporteText = (where) => {
    return service.reporteText(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  return {
    listado,
    exportar,
    reporte,
    reporteText
  };
})();